export default function readablePayMethod(meth) {
  if (meth === 'installment') return 'Intallment'
  if (meth === 'cash') return 'Pay Cash'
  if (meth === 'card') return 'Pay By Card'
  if (meth === 'bank') return 'Pay By check'
}
